import React, { useEffect, useState } from 'react';
import { Table, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { selectMachineSafetyChecklistData } from './store/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMachineSafetyChecklistRecords } from './store/slice';
import { ACTION_MODE } from '../../core/constants/constants';
import { format } from 'date-fns';

const initData = {
  date: '',
  changedBy: '',
  field: '',
  type: '',
  changes: '',
  action: '',
};

const formatDate = date => {
  if (!date) return '';
  try {
    return format(new Date(date), 'MM/dd/yyyy');
  } catch (err) {
    console.error('Invalid date:', date);
    return '';
  }
};

const SafetyChecklistHistory = ({onActionClick ,machineId}) => {
  const [formData, setFormData] = useState([]);
  const dispatch = useDispatch();

  const safetyData = useSelector(selectMachineSafetyChecklistData);

  useEffect(() => {
    dispatch(fetchMachineSafetyChecklistRecords(machineId));
  }, []);

   const handleViewClick = record => {
     onActionClick(ACTION_MODE.VIEW);
   };

 const handleCopyToCell = record => {
    onActionClick({ ...record.currentData, id: 0 }, ACTION_MODE.COPY_TO_CELL);
  };

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: text => <a>{formatDate(text)}</a>,
    },
    // {
    //   title: 'Changed By',
    //   dataIndex: 'changedby',
    //   key: 'changedby',
    // },
    // {
    //   title: 'Field',
    //   dataIndex: 'field',
    //   key: 'field',
    // },
    {
      title: 'Type',
      key: 'type',
      dataIndex: 'type',
      render: () => (
        <span 
          className="badge" 
          style={{
            backgroundColor: '#d4edda',
            color: '#155724',
            padding: '5px 12px',
            borderRadius: '4px',
            fontSize: '13px',
          }}
        >
          Safety Check
        </span>
      ),
    },
    // {
    //   title: 'Changes',
    //   key: 'changes',
    //   dataIndex: 'changes',
    //    render: (changes) => <div><span className="text-decoration-line-through text-red"> {changes.oldValue}</span> <span className="text-green"> {changes.newValue}</span> </div>,
    // },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-sm"
            style={{
              backgroundColor: '#e9ecef',
              color: '#495057',
              border: 'none',
              padding: '5px 15px',
              borderRadius: '4px',
            }}
            onClick={() => handleViewClick(record)}
          >
            View
          </button>
          <button
            className="btn btn-sm"
            style={{
              backgroundColor: '#e9ecef',
              color: '#495057',
              border: 'none',
              padding: '5px 15px',
              borderRadius: '4px',
            }}
            onClick={() => handleCopyToCell(record)}
          >
            Copy to Cell
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="row border m-3">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <Table columns={columns}
            expandable={{
             // expandedRowRender: record => <p style={{ margin: 0 }}>{record.description}</p>,
              //rowExpandable: record => record.name !== 'Not Expandable',
            }}
            dataSource={safetyData}
          />
        </div>
      </div>
    </>
  );
};

export default SafetyChecklistHistory;
